import React, {
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import {AgGridReact} from '@ag-grid-community/react';
import '@ag-grid-community/styles/ag-grid.css';
import "@ag-grid-community/styles/ag-theme-alpine.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import '../../../component/css/agGridGraph.css';
import axios from "axios";
import {API_EQUIPAGE_REPAIR} from "../../../service/api.endpoint";
import {Loader} from '@consta/uikit/LoaderCanary';
import {CellDoubleClickedEvent} from "@ag-grid-community/core";
import ModalEquipageNewRepair from "./modal.equipage.newRepair";
import {LicenseManager} from "@ag-grid-enterprise/core";
import moment from "moment/moment";

const license = process.env.REACT_APP_AGGRID
if (license) {
    LicenseManager.setLicenseKey(license);
}

interface RepairListInt {
    isUpdate: boolean
    onSummaryChange?: (summary: {total: number, active: number}) => void
    statusFilter?: 'all' | 'active' | 'completed'
}

const GridEquipageRepairList: React.FC<RepairListInt> = ({isUpdate, onSummaryChange, statusFilter = 'all'}) => {
    const gridRef = useRef<any>();
    const [rowData, setRowData] = useState<any>();
    const [isLoading, setIsLoading] = useState(false);
    const [graphParam, setGraphParam] = useState<any>()
    const [graphNode, setGraphNode] = useState<any>()
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleModalClose = (value: any) => {
        setIsModalOpen(false);
        setGraphParam(null)
        setGraphNode(null)

    };
    const onCellDoubleClicked = (params: CellDoubleClickedEvent) => {
        setIsModalOpen(true)
        setGraphParam({
            collName: params.colDef.field
        })
        setGraphNode(params.node)
    }

    // const defaultFilter = {
    //     filterType: 'date',
    //     comparator: '<',
    //     dateFrom: new Date().toISOString()
    // }

    const columnDefs = [
        {
            field: 'id',
            headerName: 'id',
            hide: true
        },
        {
            field: 'equipage',
            headerName: 'Гос. номер',
            width: 120,
            minWidth: 105,
            filter: true,
            enableRowGroup: true,
        },
        {
            field: 'org',
            headerName: 'ПО',
            width: 170,
            minWidth: 130,
            filter: true,
            enableRowGroup: true,
            rowGroup: true,
            hide: true,
        },
        {
            field: 'repair_status',
            headerName: 'Статус',
            width: 115,
            minWidth: 105,
            valueGetter: (params: any) => {
                if (!params.data) {
                    return ''
                }

                return params.data.date_to ? 'Завершен' : 'В ремонте'
            },
            cellStyle: (params: any): any => {
                if (!params.data) {
                    return null
                }

                return params.data.date_to
                    ? {background: '#eaf5e8', color: '#2f6b2f', fontWeight: 600}
                    : {background: '#fff4e5', color: '#8a4b08', fontWeight: 600}
            },
            filter: true,
        },
        {
            field: 'created_at',
            headerName: 'Добавлен',
            width: 145,
            minWidth: 130,
            filter: true,
            valueFormatter: (params: any) => params.value ? moment(params.value).add(5, 'hour').format('DD.MM.YYYY HH:mm') : '—'
        },
        {
            field: 'updated_at',
            headerName: 'Обновлен',
            width: 145,
            minWidth: 130,
            filter: true,
            valueFormatter: (params: any) => params.value ? moment(params.value).add(5, 'hour').format('DD.MM.YYYY HH:mm') : '—'
        },
        {
            field: 'date_from',
            headerName: 'Начало ремонта',
            width: 125,
            minWidth: 115,
            filter: true,
            valueFormatter: (params: any) => params.value ? moment(params.value).format('DD.MM.YYYY') : '—'
        },
        {
            field: 'date_to',
            headerName: 'Окончание',
            width: 125,
            minWidth: 115,
            filter: true,
            valueFormatter: (params: any) => params.value ? moment(params.value).format('DD.MM.YYYY') : '—'
        },
        {
            field: 'comment',
            headerName: 'Примечание',
            minWidth: 220,
            flex: 1.4,
            valueFormatter: (params: any) => params.value || '—',
        },
        {
            field: 'fio',
            filter: true,
            headerName: 'ФИО ответственного',
            minWidth: 180,
            flex: 1,
            enableRowGroup: true,
            valueFormatter: (params: any) => params.value || '—',
        },

    ];

    const getRowId = useMemo(() => {
        return (params: any) => {
            return params.data.id
        };
    }, []);

    const defaultColDef = useMemo(() => {
        return {
            sortable: true,
            resizable: true,
            suppressHeaderContextMenu: true,
        };
    }, []);

    const autoGroupColumnDef = useMemo(() => {
        return {
            headerName: 'Подрядчик',
            minWidth: 240,
            cellRendererParams: {
                suppressCount: false,
            },
        };
    }, []);

    const filteredRows = useMemo(() => {
        const rows = Array.isArray(rowData) ? rowData : []

        if (statusFilter === 'active') {
            return rows.filter((item: any) => !item.date_to)
        }

        if (statusFilter === 'completed') {
            return rows.filter((item: any) => item.date_to)
        }

        return rows
    }, [rowData, statusFilter])


    const fetchData = async () => {
        try {
            // console.time("fetchData"); // Засекаем время выполнения
            const response = await axios.get(API_EQUIPAGE_REPAIR, {
                params: {
                    name: localStorage.getItem('username'),
                    company: localStorage.getItem('company')
                }
            });
            // console.timeEnd("fetchData"); // Выводим время выполнения в консоль
            const rows = Array.isArray(response.data) ? response.data : []
            onSummaryChange?.({
                total: rows.length,
                active: rows.filter((item: any) => !item.date_to).length,
            })
            return rows

            // return response.data
        } catch (error) {
            console.log(error);
            onSummaryChange?.({total: 0, active: 0})
            return []
        } finally {
            setIsLoading(false);
        }
    };

    const onGridReady = async (params: any) => {
        // const data = await fetchData()
        setRowData(await fetchData())
    };

    useEffect(() => {
        setIsLoading(true)
        onGridReady(null); // Вызываем функцию при монтировании компонента
    }, []);

    useEffect(() => {
        setIsLoading(true)
        onGridReady(null); // Вызываем функцию при монтировании компонента
    }, [isUpdate]);

    const statusBar = useMemo(() => {
        return {
            statusPanels: [
                {statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left'},
            ],
        };
    }, []);

    return (
        <div className="equipage-grid-card">
            <div className="ag-theme-alpine equipage-repair-grid">
                {isLoading && !rowData && (
                    <div className="equipage-grid-loader">
                        <Loader/>
                    </div>
                )}
                <AgGridReact
                    ref={gridRef}
                    rowData={filteredRows}
                    columnDefs={columnDefs}
                    animateRows={true}
                    getRowId={getRowId}
                    defaultColDef={defaultColDef}
                    autoGroupColumnDef={autoGroupColumnDef}
                    onGridReady={onGridReady}
                    statusBar={statusBar}
                    onCellDoubleClicked={onCellDoubleClicked}
                    rowGroupPanelShow={'always'}
                />
            </div>
            <ModalEquipageNewRepair isOpen={isModalOpen}
                                    onClose={handleModalClose}
                                    props={graphParam}
                                    nodeData={graphNode}/>
        </div>
    );
};

export default GridEquipageRepairList;
